
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/[id]",
      function () {
        return require("private-next-pages/form/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/[id]"])
      });
    }
  